import axios from 'axios'
import { Agent, AgentOptions } from 'node:http'
import https from 'https'

const keepAliveSettings: AgentOptions = {
  keepAlive: true,
  keepAliveMsecs: 60_000,
  maxSockets: 100,
  maxFreeSockets: 20,
  scheduling: 'lifo',
}

export const httpServerClient = axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
    ...keepAliveSettings,
  }),
  httpAgent: new Agent({
    ...keepAliveSettings,
  }),
})
